document.querySelectorAll('.tile-promo__heading').forEach(block => {
  block.addEventListener('click', e => {
    block.parentElement.classList.toggle('active');
  });
})